import { Text } from '@talkdesk/cobalt-react-typography'
import Box from '@talkdesk/cobalt-react-box'
import Flex from '@talkdesk/cobalt-react-flex'
import Base from '../../pages/Base'
import MFAHeader from '../../components/MFAHeader'
import MFACard from '../../components/MFACard'
import {
  MFA_SELECTOR_TITLE,
  MFA_SELECTOR_SUBTITLE,
  MFA_SELECTOR_FOOTNOTE
} from '../../constants/ui.labels'
import { useTheme } from '@talkdesk/cobalt-react-theme-provider'

const MFASelector = ({
  brandingSettings,
  redirect,
  mfas,
  selectMFA,
  changeStep,
  showGoogleFooterLink
}) => {
  const theme = useTheme()

  return (
    <Base
      brandingSettings={brandingSettings}
      redirect={redirect}
      showGoogleFooterLink={showGoogleFooterLink}
    >
      <MFAHeader title={MFA_SELECTOR_TITLE} subtitle={MFA_SELECTOR_SUBTITLE} />
      {mfas.map(mfa => {
        return (
          <MFACard
            key={mfa.type}
            mfaType={mfa.type}
            selectMFA={selectMFA}
            changeStep={changeStep}
          />
        )
      })}
      <Box paddingTop={5}>
        <Flex alignX="center">
          <Text color={theme.gray11} size="small">
            {MFA_SELECTOR_FOOTNOTE}{' '}
          </Text>
        </Flex>
      </Box>
    </Base>
  )
}

export default MFASelector
